import MetabaseDashboard from "./MetabaseDashboard";

export default MetabaseDashboard;
